<template>
  <canvas :width="width"
    :height="height"
    ref="grid">
  </canvas>
</template>
<script>

export default {
	props: {
		width: Number,//网格的宽
		height: Number//网格的高
	},
	data() {
		return {
			canvas: {},
			lineWidth: 1,//刻度宽度	
			deepColor: '#424242',//每5个间隔的深色刻度颜色
			undertintColor: '#424242'//普通刻度的颜色
		};
	},
	computed: {
		higherRankSpaing() {
			/*const obj = {
				1: 50,
				0.9: 60,
				0.8: 80,
				0.7: 120,
				0.6: 160,
				0.5: 200,
				0.4: 250,
				0.3: 300,
				0.2: 400,
				0.1: 500
			};*/
			const obj = {
				1: 130,
				0.625: 150,
				0.5: 120,
				0.3125: 100,
				0.25: 80
			}
			return obj[this.scalelevel];
		},
		scalelevel() {//缩放等级:0.3-1
			return this.$store.getters['defaultImgOptions/getScaleLevel'];
		},
		gridRowsNum() {//纵向刻度数量 高度/x轴刻度间距
			return this.height / this.xTickSpacing;
//			return 480;
		},
		gridColsNum() {//横向刻度数量 宽度/y轴刻度间距
			return this.width / this.yTickSpacing;
//			return 344;
		},
		xTickSpacing() {//x轴刻度间距 不同缩放等级间距不一样
			return (this.higherRankSpaing / 5) * this.scalelevel;
		},
		yTickSpacing() {//y轴刻度间距 不同缩放等级间距不一样
			return (this.higherRankSpaing / 5) * this.scalelevel;
		}
	},
	mounted() {
		this.canvas = this.$refs.grid;
		let ctx = this.canvas.getContext('2d');
		this.$nextTick(()=>{
			this.$options.methods.drawGrid(this, ctx);
		});
	},
	methods: {
		draw() {
			let ctx = this.canvas.getContext('2d');
			ctx.clearRect(0, 0, this.width, this.height);
			this.drawGrid(this, ctx);
		},
		drawGrid(_this, ctx) {
			for (var col = 0; col <= _this.gridColsNum; col++) {
				//竖线
				ctx.beginPath();
				if (col % 5 == 0) {
					let x = col * _this.yTickSpacing;
					ctx.moveTo(x + 0, 1);
					ctx.lineTo(x + 0, _this.height);
					ctx.strokeStyle = _this.deepColor;
				} else {
					ctx.beginPath();
					let x = col * _this.yTickSpacing;
					ctx.moveTo(x + 0, 1);
					ctx.lineTo(x + 0, _this.height);
					ctx.strokeStyle = _this.undertintColor;
				}
				ctx.stroke();
			}
			for (var row = 0; row <= _this.gridRowsNum; row++) {
				//横线
				if (row % 5 == 0) {
					ctx.beginPath();
					var y = row * _this.xTickSpacing;
					ctx.moveTo(0, y + 0);
					ctx.lineTo(_this.width, y + 0);
					ctx.strokeStyle = _this.deepColor;
				} else {
					ctx.beginPath();
					let y = row * _this.xTickSpacing;
					ctx.moveTo(0, y + 0);
					ctx.lineTo(_this.width, y + 0);
					ctx.strokeStyle = _this.undertintColor;
				}
				ctx.stroke();
			}
		}
	},
	watch: {
		scalelevel() {//缩放等级变化重绘
		  this.draw();
			// let ctx = this.canvas.getContext('2d');
			// ctx.clearRect(0, 0, this.width, this.height);
			// this.drawGrid(this, ctx);
		},
		// screenWidth() {
		// 	let ctx = this.canvas.getContext('2d');
		// 	ctx.clearRect(0, 0, this.width, this.height);
		// 	this.drawGrid(this, ctx);
		// },
		height() {//F11全屏重绘
			setTimeout(() => {
				this.draw();
			}, 500);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Grid/Grid.vue